<template>
  <div></div>
</template>

<script>
export default {
  name: "ServiceErrorDialog",
  created() {
    if (window.localStorage.getItem("updated")) {
      this.$confirm("La aplicación de operadora se ha actualizado.", "Aplicación actualizada", {
        confirmButtonText: "Aceptar",
        type: "info",
        showCancelButton: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
      })
        .then(() => {
          window.localStorage.removeItem("updated");
        })
        .catch(() => {
          window.localStorage.removeItem("updated");
        });
    }
  },
};
</script>
